<template>
  <section class="c-table-end">
    <router-link to="/" class="c-table-end__home c-table-end__link t-t2">
        Retourner à la page d'accueil
    </router-link>

    <router-link
      v-if="next && next.title"
      :to="{
        name: 'project',
        params: { id: next.id, slug: slug },
      }"
      class="c-table-end__project c-table-end__link"
    >
      <p class="c-table-end__name t-t2">
        Prochain projet : {{ next.title }}
      </p>
      <img
        :src="next.image.url"
        :alt="next.image.alt"
        class="c-table-end__image"
      />
    </router-link>
  </section>
</template>

<script>
import slugify from "slugify";

export default {
  name: "LinksEnd",
  props: {
    name: String,
    category: String,
    value: String,
    projects: Array,
    next: Object,
  },
  data() {
    return {
      slug: " ",
    };
  },
  mounted() {
    this.saveSlug();
  },
  updated() {
    this.saveSlug();
  },
  methods: {
    saveSlug() {
      if (this?.next?.title) {
        this.slug = slugify(this.next.title, {
          replacement: "_", // replace spaces with replacement character, defaults to `-`
          remove: /[*+~.()'"!:@]/g, // remove characters that match regex, defaults to `undefined`
          lower: true, // convert to lower case, defaults to `false`
          locale: "fr", // language code of the locale to use
        });
      }
    },
  },
};
</script>

<style lang="sass">
.c-table-end
  border-top: solid 5px $black
  border-bottom: solid 5px $black
  padding: 4rem 0
  display: flex
  align-items: center
  justify-content: space-between

  +break-max($tablet)
    flex-direction: column-reverse
    text-align: center
    border-width: 2px
    br
      display: none

  &__link
    position: relative

    +break-max($tablet)
      margin-bottom: 3rem

      &:first-child
        margin-bottom: 0

    &:before
      +absolute(50%, auto, auto, -30px)
      content: "👉"
      font-size: 20px
      transform: translateY(-50%)
      opacity: 0

    &:hover
      &:before
        opacity: 1

  &__home
    flex-grow: 1

  &__project
    display: flex
    justify-content: flex-end
    align-items: center

  &__image
    +size(11.5rem)
    border-radius: 100%
    overflow: radius
    display: block
    object-fit: cover

    +break-max($tablet)
      display: none

  &__name
    text-align: right
    margin-right: 4rem

    +break-max($tablet)
      margin-right: 0
</style>
